var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a',{staticClass:"skip-link",attrs:{"href":"#conteudo","id":"link-conteudo","accesskey":"1"}},[_vm._v("\n    Ir para o conteúdo principal [1]\n  ")]),_vm._v(" "),_c('a',{staticClass:"skip-link",attrs:{"href":"#menu","id":"link-menu","accesskey":"2"}},[_vm._v("\n    Ir para o menu principal [2]\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebd4068","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = uQen
// module chunks = 15